import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  Alert,
} from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';

import {
  getLeadUsers,
  updateLead,
  getLeads,
} from '../../../../redux/actions/lead';
import { useAssignedValidation } from './formik';

function AssignedForm({ leadId, leadOrder, onSubmit, onCancel }) {
  const [modal, setModal] = useState(true);
  const dispatch = useDispatch();
  const userState = useSelector((state) => state.lead.users);
  const updateState = useSelector((state) => state.lead.update);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [users, setUsers] = useState([]);

  const formik = useAssignedValidation((values) => {
    setLoading(true);
    setErrorMessage('');

    if (!leadId) {
      setErrorMessage('No se puede asignar: ID de lead no válido.');
      setLoading(false);
      return;
    }

    const leadInfo = {
      state: 'assigned',
      userEmail: values.userEmail,
      order: leadOrder,
    };

    dispatch(updateLead(leadId, leadInfo));
  });

  const toggle = (operation) => {
    setModal(!modal);
    if (operation === 'submit') {
      onSubmit();
    } else {
      onCancel();
    }
  };

  useEffect(() => {
    dispatch(getLeadUsers());
  }, [dispatch]);

  useEffect(() => {
    if (userState?.data) {
      setUsers(userState.data);
    }
  }, [userState]);

  useEffect(() => {
    if (updateState) {
      setLoading(false);

      if (updateState.status === 'success') {
        toggle('submit');
        dispatch(getLeads());
      } else if (updateState.status === 'danger') {
        setErrorMessage(updateState.message || 'Error al asignar el lead');
      }
    }
  }, [updateState]);

  return (
    <Modal isOpen={modal} toggle={() => toggle('cancel')}>
      <ModalHeader toggle={() => toggle('cancel')}>Asignar Lead</ModalHeader>
      <Form onSubmit={formik.handleSubmit}>
        <ModalBody>
          {errorMessage && (
            <Alert color="danger" className="mb-3">
              {errorMessage}
            </Alert>
          )}

          <p>
            Selecciona el vendedor al que deseas asignar este lead. El vendedor
            podrá comenzar a gestionar el seguimiento del cliente potencial.
            Asegúrate de elegir al vendedor más adecuado.
          </p>
          <FormGroup className="mb-3">
            <Label for="userEmail">Vendedor</Label>
            <Input
              type="select"
              name="userEmail"
              id="userEmail"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.userEmail}
              valid={formik.touched.userEmail && !formik.errors.userEmail}
              invalid={formik.touched.userEmail && !!formik.errors.userEmail}
            >
              <option value="">Selecciona un vendedor</option>
              {users.map((user) => (
                <option key={user.email} value={user.email}>
                  {user.name} ({user.email}) - {user.role}
                </option>
              ))}
            </Input>
            <FormFeedback>{formik.errors.userEmail}</FormFeedback>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button
            type="submit"
            color="primary"
            disabled={!formik.isValid || !formik.dirty || loading}
          >
            {loading ? 'Asignando...' : 'Asignar'}
          </Button>{' '}
          <Button color="secondary" onClick={() => toggle('cancel')}>
            Cancelar
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
}

export default AssignedForm;
